module.exports = __webpack_public_path__ + "static/assets/852e415b32e5db0074500f7a27d85e5c.png";